import script from "./moShipmentListDetail.vue?vue&type=script&setup=true&name=moShipmentListDetail&lang=js"
export * from "./moShipmentListDetail.vue?vue&type=script&setup=true&name=moShipmentListDetail&lang=js"

const __exports__ = script;

export default __exports__